export const createPrintIntentPayload = (cart, couponCode, checkoutAttemptId) => ({
  lines: cart.map((line) => ({ ...line })),
  couponCode,
  currency: 'eur',
  checkoutAttemptId,
});

export const isPrintIntentDiagnosticAvailable = (apiUrl, nodeEnv) =>
  nodeEnv === 'development' || apiUrl === 'https://api-stage.getbloomup.com/v1';

export const createPrintPaymentIntent = async ({ cart, couponCode, checkoutAttemptId }) => {
  const response = await fetch(process.env.REACT_APP_API_URL + '/payments/create-intent', {
    method: 'POST',
    body: JSON.stringify(createPrintIntentPayload(cart, couponCode, checkoutAttemptId)),
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token') },
  });
  return { response, paymentIntent: await response.json() };
};
